export default {
    namespaced: true,
    state: {
        cartList: [],
    },
    getters: {

    },
    mutations: {
        setCartList(state, payload) {
            let tag = true;
            state.cartList.forEach((ele)=>{
                if ( ele.id==payload.id) {
                    ele.buy_num+=1;
                    tag = false;
                }
            }) 
            if(tag){
                payload.buy_num +=1;
                state.cartList.push(payload);
            }
        },
        delCartList(state) {
            state.cartList = []
        },
    },
    actions: {

    },

}